import React from 'react'
import { TFunction } from 'next-i18next'
import { CustomDatePicker, CustomTextInput, CountrySelector } from 'src/components'
import { User } from 'src/core/models'

interface FormProps {
  name: string,
  required: boolean,
  placeholder: string,
  onChange?: Function
  handleOnChange?: Function
}

interface PersonalDetailSection {
  formLabels: {
    title: string,
    subtitle: string
  },
  formComponent: React.FunctionComponent<FormProps | any> // Conflict with Select Props,
  formProps: FormProps
}

export const personalDetailsSections = (
  t: TFunction, handleValidation: Function, user: User
): PersonalDetailSection[] => [

  { // Email
    formLabels: {
      title: `${t('settings.Email')} *`,
      subtitle: t('settings.EmailLabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'email',
      required: true,
      placeholder: t('settings.EmailPlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'email')
    }
  },

  { // First Name
    formLabels: {
      title: `${t('settings.FirstName')} *`,
      subtitle: t('settings.FirstNameLabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'first_name',
      required: true,
      placeholder: t('settings.FirstNamePlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'first_name')
    }
  },

  { // Last Name
    formLabels: {
      title: `${t('settings.LastName')} *`,
      subtitle: t('settings.LastNameLabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'last_name',
      required: true,
      placeholder: t('settings.LastNamePlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'last_name')
    }
  },

  { // Birth Data
    formLabels: {
      title: t('settings.BirthDate'),
      subtitle: t('settings.BirthDateLabel')
    },
    formComponent: CustomDatePicker,
    formProps: {
      name: 'birth_date',
      required: false,
      placeholder: t('settings.BirthDatePlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'birth_date')
    }
  },

  { // DNI
    formLabels: {
      title: `${t('settings.DNI')} ${user?.is_individual ? '*': ''}`,
      subtitle: t('settings.DNILabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'id_number',
      required: user?.is_individual,
      placeholder: t('settings.DNIPlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'id_number')
    }
  },

  { // Address
    formLabels: {
      title: t('settings.Address'),
      subtitle: t('settings.AddressLabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'street',
      required: false,
      placeholder: t('settings.AddressPlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'street')
    }
  },

  { // Postal Code
    formLabels: {
      title: t('settings.PostalCode'),
      subtitle: t('settings.PostalCodeLabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'postal_code',
      required: false,
      placeholder: t('settings.PostalCodePlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'postal_code')
    }
  },

  { // City
    formLabels: {
      title: t('settings.City'),
      subtitle: t('settings.CityLabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'city',
      required: false,
      placeholder: t('settings.CityPlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'city')
    }
  },

  { // State
    formLabels: {
      title: t('settings.Province'),
      subtitle: t('settings.ProvinceLabel')
    },
    formComponent: CustomTextInput,
    formProps: {
      name: 'state',
      required: false,
      placeholder: t('settings.ProvincePlaceHolder'),
      onChange: (v: string) => handleValidation(v, 'state')
    }
  },

  { // Country
    formLabels: {
      title: t('settings.Country'),
      subtitle: t('settings.ChoseCountry')
    },
    formComponent: CountrySelector,
    formProps: {
      name: 'country',
      required: true,
      placeholder: t('settings.CompanyCountry'),
      handleOnChange: (v: number) => handleValidation(v, 'country')
    }
  },
]
